import { EventFeedEvent } from '@api';
import { getEntityTagFromSnake } from '@helpers';
import { CardType } from '@terminal/views/insight-feed/components/insight-feed-card/InsightFeedCard';

export const parseCatalystData = (event: EventFeedEvent) => {
  const eventDate = new Date(event.created_at);
  const isMarketWide = event.metadata.category === 'market_wide';
  const subCategory = event.metadata.sub_category;
  const cardType = isMarketWide
    ? CardType.MarketCatalyst
    : CardType.CompanyCatalyst;
  const isThematic = subCategory === 'thematic';
  const themeId = isThematic
    ? event.metadata.identifier ?? undefined
    : undefined;

  return {
    eventDate,
    isMarketWide,
    cardType,
    themeId,
    subCategory,
  };
};

export const getCatalystEntityTag = (event: EventFeedEvent): string => {
  const firstSnake = event.metadata.snakes?.[0];
  return firstSnake ? getEntityTagFromSnake(firstSnake) : event.entity;
};
